import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { SampleDetailComponent } from '../components/sample-detail/sample-detail.component';
import { DetailComponentConfig } from '../models/detail-component-config';
import { DetailRenderType } from '../models/detail-render-type';

@Injectable()
export class DetailCompResolverService {
  constructor() {

  }
  resolve(node: TreeNode): DetailComponentConfig {
    return {
      detailRenderType: DetailRenderType.Component,
      componentType: SampleDetailComponent
    }
  }
}
